// extracted by mini-css-extract-plugin
module.exports = {"link":"card-module--link--1rD8c","textOverlay":"card-module--textOverlay--GkO2E","cardOverlayBackground":"card-module--cardOverlayBackground--3yYmb"};